import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { startCheckout } from "@/lib/billing";

export const BUY_KEY = "rpopro_buy_intent";
const LS = (k) => `rpopro_onboarding_${k || "anon"}`;

let key = null, remote = true;
let state = { steps: {}, tour_done_at: null, checklist_hidden: false, loaded: false };
const subs = new Set();
const emit = () => { if (key) localStorage.setItem(LS(key), JSON.stringify({ ...state, loaded: undefined })); subs.forEach((f) => f(state)); };
const push = (patch) => remote && api.put("/onboarding/progress", patch).catch((e) => { if ([404, 405].includes(e.response?.status)) remote = false; });

// GET/PUT /onboarding/progress (spec §26); falls back to this browser until live.
export const loadProgress = async (userKey) => {
  if (key === userKey && state.loaded) return;
  if (key !== userKey) state = { steps: {}, tour_done_at: null, checklist_hidden: false, loaded: false };
  key = userKey;
  let local = {};
  try { local = JSON.parse(localStorage.getItem(LS(key)) || "{}"); } catch { local = {}; }
  let srv = {};
  try { srv = (await api.get("/onboarding/progress")).data || {}; remote = true; }
  catch (e) { remote = ![404, 405].includes(e.response?.status); }
  const steps = { ...(local.steps || {}), ...state.steps, ...(srv.steps || {}) };
  state = { steps, tour_done_at: srv.tour_done_at || local.tour_done_at || null, checklist_hidden: !!(srv.checklist_hidden || local.checklist_hidden), loaded: true };
  emit();
  const missing = Object.fromEntries(Object.entries(steps).filter(([k]) => !srv.steps?.[k]));
  if (Object.keys(missing).length && remote) push({ steps: missing });
};

export const markStep = (id) => {
  if (!key || state.steps[id]) return;
  const at = new Date().toISOString();
  state = { ...state, steps: { ...state.steps, [id]: at } };
  emit(); push({ steps: { [id]: at } });
};
export const setFlag = (k, v) => { state = { ...state, [k]: v }; emit(); push({ [k]: v }); };

export const useOnboarding = () => {
  const [s, setS] = useState(state);
  useEffect(() => { subs.add(setS); setS(state); return () => subs.delete(setS); }, []);
  return s;
};

const RULES = [
  [/^\/applications$/, "post", "save"],
  [/^\/alerts$/, "post", "alert"],
  [/^\/resume-builder\//, "post", "resume"],
  [/^\/ai\/chat\/[^/]*interview[^/]*\/start$/i, "post", "interview"],
  [/^\/wellbeing\//, "get", "wellbeing"],
];
api.interceptors.response.use((r) => {
  const url = String(r.config?.url || "").replace(/^https?:\/\/[^/]+/, "").replace(/^\/api/, "").split("?")[0];
  const m = (r.config?.method || "get").toLowerCase();
  RULES.forEach(([re, meth, id]) => { if (meth === m && re.test(url)) markStep(id); });
  return r;
});

export const openTour = (kind = "spotlight") => window.dispatchEvent(new CustomEvent("rpopro:tour", { detail: kind }));

export const googleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/search";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const buyPlan = (product, yearly, authed) => {
  const interval = yearly ? "year" : undefined;
  if (authed) return startCheckout(product, "/upgrade", undefined, interval);
  localStorage.setItem(BUY_KEY, JSON.stringify({ product, interval, at: Date.now() }));
  googleLogin();
  return Promise.resolve(true);
};
